
import { getPermissionMatrixCall } from "lib/axiosUtils";

export const getPermissionMatrix = async () => {
    const permissionMatrix = await getPermissionMatrixCall({}, {});
    localStorage.setItem("userRolePermission", JSON.stringify(permissionMatrix.data.result));
}

export const hasPermission = (resource, action) => {
    let permissionValue = false;
    const userRole = JSON.parse(localStorage.getItem("userRole"));
    const userRolePermission = JSON.parse(localStorage.getItem("userRolePermission"));

    if (userRolePermission) {
        userRolePermission[0].roles.forEach((roleItem) => {
            if (roleItem.role_name.toLowerCase() === userRole.user_role.replace(" ", "").toLowerCase()) {
                permissionValue = roleItem.permission?.modules?.[resource]?.[action] ?? false;
            }
        });
    }

    return permissionValue;
};

export const hasRoutePermission = (route) => {
    let permissionValue = false;
    const userRole = JSON.parse(localStorage.getItem("userRole"));
    const userRolePermission = JSON.parse(localStorage.getItem("userRolePermission"));
    if (userRolePermission) {
        userRolePermission[0].roles.forEach((roleItem) => {
            if (roleItem.role_name.replace(" ", "").toLowerCase() === userRole.user_role.replace(" ", "").toLowerCase()) {
                permissionValue = roleItem.permission?.routes?.includes(route) ?? false;
            }
        })
    }
    return permissionValue;
}

export const hasStepPermission = (resource) => {
    let permissionValue = false;
    const userRole = JSON.parse(localStorage.getItem("userRole"));
    const userRolePermission = JSON.parse(localStorage.getItem("userRolePermission"));
    if (userRolePermission) {
        userRolePermission[0].roles.forEach((roleItem) => {
            if (roleItem.role_name.toLowerCase() === userRole.user_role.replace(" ", "").toLowerCase()) {
                permissionValue = roleItem.permission?.steps?.[resource] ?? false;
            }
        })
    }
    return permissionValue;
}